/**
 * Extracts raw filter options from a filters response based on a given classifier ID.
 *
 * The function processes two formats of input:
 * 1. A flat list where each item has a `classifier_id`.
 * 2. A nested format where each item has a `classifier_values` array, and each of those
 *    values has a `classifier_id`.
 * It collects all options that match the provided `classifierId`.
 * @param {string|number} classifierId - The ID of the classifier to filter by.
 * @param {Array<object>} filtersResponse - The array of filter objects returned by the API.
 * @returns {Array<object>} An array of raw filter options matching the given classifier ID.
 */
export function rawOptionsFromFiltersResponse(
  classifierId: number | string,
  filtersResponse: any[],
): any[] {
  const rawOptions = []

  if (filtersResponse.every((filterOption) => filterOption.classifier_id)) {
    rawOptions.push(
      ...filtersResponse.filter((filterOption) => {
        if (filterOption.classifier_id) {
          return filterOption.classifier_id == classifierId
        }
      }),
    )
  }

  if (filtersResponse.every((filterOption) => filterOption.classifier_values)) {
    const classifiersValues = filtersResponse.flatMap(
      (filterOption) => filterOption.classifier_values,
    )

    rawOptions.push(
      ...classifiersValues.filter((filterOption) => filterOption.classifier_id == classifierId),
    )
  }

  return rawOptions
}
